import { render, staticRenderFns } from "./FormatList.vue?vue&type=template&id=33665925"
import script from "./FormatList.vue?vue&type=script&lang=js"
export * from "./FormatList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports